import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { environment } from 'src/environments/environment';

export const signInProtectionGuard: CanActivateFn = () => {
  const router = inject(Router);

  // Only block sign-in if both Retail IDAM clientId and URL are configured
  // If only one is set, allow sign-in page to be accessible
  if (environment.clientIdForRetailIDAM && environment.retailIDAMURL) {
    router.navigate(['/']).catch(() => {});
    return false;
  } else {
    return true;
  }
};
